<div *ngIf="isProcessing" class="overlay" [class.light]="isLightOverLay" [class.dark]="!isLightOverLay">
  <mat-spinner *ngIf="isProcessing" class="spinner_container"></mat-spinner>
</div>